import React, { useEffect, useState } from "react";
import { api } from "@/lib/config";
import { Trash2, Mail, Check, X } from "lucide-react";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/admin/messages").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const onToggleHandled = async (m) => {
    await api.put(`/admin/messages/${m.id}`, { handled: !m.handled });
    load();
  };

  const onDelete = async (id) => {
    if (!window.confirm("Supprimer ce message ?")) return;
    await api.delete(`/admin/messages/${id}`); setSelected(null); load();
  };

  return (
    <div>
      <p className="section-num">Messages</p>
      <h1 className="display text-4xl mt-3">Messages du formulaire de contact</h1>
      <p className="text-ink/60 mt-2">{items.filter(m => !m.handled).length} non traités sur {items.length} total</p>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-5 bg-paper border border-ink/10 max-h-[80vh] overflow-y-auto">
          {items.length === 0 && <p className="p-8 text-ink/60">Aucun message reçu.</p>}
          {items.map(m => (
            <button
              key={m.id}
              onClick={() => setSelected(m)}
              className={`w-full text-left p-5 border-b border-ink/10 hover:bg-paper-2 transition-colors ${selected?.id === m.id ? "bg-paper-2" : ""}`}
              data-testid={`admin-msg-${m.id}`}
            >
              <div className="flex items-center justify-between gap-3">
                <p className="display text-base truncate">{m.name}</p>
                {!m.handled && <span className="text-[10px] uppercase tracking-wider bg-accent-pink text-white px-2 py-0.5">Nouveau</span>}
              </div>
              <p className="text-sm text-ink/60 truncate mt-1">{m.email} {m.company && `· ${m.company}`}</p>
              <p className="text-xs text-ink/40 mt-1">{new Date(m.created_at).toLocaleString("fr-FR")}</p>
            </button>
          ))}
        </div>

        <div className="lg:col-span-7">
          {!selected ? (
            <div className="bg-paper border border-ink/10 p-12 text-center text-ink/50">
              <Mail size={32} className="mx-auto mb-4 opacity-50"/>
              Sélectionnez un message pour le consulter.
            </div>
          ) : (
            <div className="bg-paper border border-ink/10 p-8">
              <div className="flex items-start justify-between">
                <div>
                  <p className="display text-2xl">{selected.name}</p>
                  <p className="text-ink/60 text-sm mt-1"><a className="editorial-link" href={`mailto:${selected.email}`}>{selected.email}</a></p>
                  {selected.company && <p className="text-ink/60 text-sm">{selected.company}</p>}
                  {selected.phone && <p className="text-ink/60 text-sm">{selected.phone}</p>}
                </div>
                <div className="flex gap-2">
                  <button onClick={() => onToggleHandled(selected)} className="p-2 hover:bg-ink/5" title={selected.handled ? "Marquer comme non traité" : "Marquer comme traité"}>
                    {selected.handled ? <X size={16}/> : <Check size={16}/>}
                  </button>
                  <button onClick={() => onDelete(selected.id)} className="p-2 hover:bg-paper-2 text-accent-pink"><Trash2 size={16}/></button>
                </div>
              </div>
              {selected.subject && (
                <div className="mt-6 pt-6 border-t border-ink/10">
                  <p className="text-xs uppercase tracking-wider text-ink/60">Sujet</p>
                  <p className="display text-lg mt-1">{selected.subject}</p>
                </div>
              )}
              <div className="mt-6 pt-6 border-t border-ink/10">
                <p className="text-xs uppercase tracking-wider text-ink/60">Message</p>
                <p className="mt-3 whitespace-pre-wrap leading-relaxed text-ink/85">{selected.message}</p>
              </div>
              <p className="text-xs text-ink/40 mt-8">Reçu le {new Date(selected.created_at).toLocaleString("fr-FR")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
